export const getBiEvid = (biEvent) => biEvent.evid;
